import { createAsyncStatusStore } from "@react/foundation/zustand";

export const {
  asyncStatusSelectors: connectOnReturnSelectors,
  asyncStatusStore: connectOnReturnStore,
  useAsyncStatusStore: useConnectOnReturnStore,
} = createAsyncStatusStore();
